export default class LazyLoad {
    constructor(element) {
      this.el = element
      this.init()
    }
  
    init() {
      
      var pageLazyLoad = new LazyLoad({
        elements_selector: "[loading=lazy]",
        use_native: true // ← enables hybrid lazy loading
      });
      console.log(pageLazyLoad)
    }
  }
  